<template>
    <div>
        <b-sidebar backdrop id="add_vendor" width="50%" aria-labelledby="sidebar-no-header-title" no-header style="direction:ltr" right :title="formtitles" shadow >
            <template #default="{ hide }">
                <div class="m-1 text-start" style="direction:rtl">
                    <div style="width:120px;margin-right:10px;background:#000;color:#FFF;border-radius:5px" class="btn-primary btn-sm text-center">
                        <span>{{formtitles}}</span>
                    </div>
                        <div @click="hide" id="vendorclose" style="width:100px;text-align:center;float:left;margin-left:5px;margin-top:-25px;cursor:pointer" class="btn-danger btn-sm">
                        <span>{{lang.close}}</span>
                    </div>
                </div>
                <v-divider></v-divider>
                <div class="px-3 py-2" :style="`direction:`+lang.dir">
                    <v-row>
                        <v-col cols="12" md="6">
                            <label>{{lang.vendorid}}</label>
                            <b-form-input class="inborder"
                                v-model="vendorid"
                                readonly
                            >{{vendorid}}</b-form-input>
                        </v-col>
                        <v-col cols="12" md="6">
                            <label>{{lang.vendor_mobile}}</label>
                            <b-form-input class="inborder"
                                v-model="mobile"
                                @change="checkVendorNumber()"
                            >{{mobile}}</b-form-input>
                        </v-col>
                        <v-col cols="12" md="6">
                            <label>{{lang.vendor_category}}</label>
                            <b-form-select class="selborder"
                                v-model="is_customer"
                                :options="vendorCategories"
                            ></b-form-select>
                        </v-col>
                        <v-col cols="12" md="6">
                            <label>{{lang.vendor_name}}</label>
                            <b-form-input class="inborder"
                                v-model="full_name"
                            >{{full_name}}</b-form-input>
                        </v-col>
                        <v-col cols="12" md="6">
                            <label>{{lang.vendor_vatids}}</label>
                            <b-form-input class="inborder"
                                v-model="vatid"
                                @change="checkVendorVat()"
                            >{{vatid}}</b-form-input>
                        </v-col>
                        <v-col cols="12" md="6">
                            <label>{{lang.type}}</label>
                            <b-form-select class="selborder"
                                v-model="vendortype"
                                :options="vendortypes"
                            ></b-form-select>
                        </v-col>
                        <v-col cols="12" md="6">
                            <label>{{lang.account_type}}</label>
                            <b-form-select class="selborder"
                                v-model="vendorAcType"
                                :options="vendorActypes"
                            ></b-form-select>
                        </v-col>
                        <v-col cols="12" md="12">
                            <label>{{lang.vendor_address}}</label>
                            <b-form-input class="inborder"
                                v-model="address"
                            >{{address}}</b-form-input>
                        </v-col>
                    </v-row>
                </div>
            </template>
            <template #footer="" class="shadow">
                <div class="d-flex text-light align-items-center px-3 py-2">
                <b-button type="button" variant="success" @click='AddVendor()' class="ma-2" style="width:100px;">{{ submitname }}</b-button>
                </div>
            </template>
        </b-sidebar>
        <vue-snotify></vue-snotify>
    </div>
</template>

<script>
import axios from 'axios';
import {SnotifyPosition} from 'vue-snotify';
export default {
    data() {
        return {
            formtitle: '',
            vendorAcType: 0,
            vendorid: '',
            full_name: '',
            vendortype: 1,
            vatid: '',
            address: '',
            mobile: '',
            SUBMIT_NAME: '',
            is_customer: 1,
            classes: []
        }
    },
    computed:{
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                return this.$store.state.lang.en;
                }else{
                return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        vendorActypes: function() {
            let t = [];
            for(let i = 0; i< this.classes.length; i++){
                t.push({text: this.classes[i][`name${this.lang.langname}`], value: this.classes[i]['classid']})
            }
            return t;
        },
        vendorCategories: function() {
            return [
                {text: this.lang.only_vendor, value: 1},
                {text: this.lang.vendor_and_customer, value: 2},
            ];
        },
        submitname: function(){
            return this.SUBMIT_NAME;
        },
        formtitles: function(){
            return this.formtitle;
        },
        vendortypes: function() {
            return [
                {text: this.lang.purchase_invoice, value: 1},
                {text: 'فاتورة داخلية', value: 2},
            ]
            
        }
    },
    methods: {
        checkVendorNumber() {
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type','checkVendor');
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase))
            post.append('data[lang]',this.$cookies.get(this.$store.state.LangCooki))
            post.append('data[mobile]',this.mobile)
            post.append('data[vatid]',0)
            axios.post(
                this.$store.state.SAMCOTEC.r_path , post
            ).then((response) => {
                const res = response.data;
                if(res.results.data.length > 0){
                    this.mobile = '';
                    this.$snotify.error('رقم الاتصال مستخدم مسبقا يرجى اضافة رقم اخر', 'تنبيه', {
                        timeout: 1000000,
                        showProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        position: SnotifyPosition.centerCenter,
                        buttons: [
                            {
                                text: this.lang.close, 
                                action: (toast) => {
                                    this.$snotify.remove(toast.id); 
                                } 
                            },
                        ]
                    });
                }
                
            })
        },
        getVenClasses(){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type','getVendorClasses');
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase))
            post.append('data[lang]',this.$cookies.get(this.$store.state.LangCooki))
            post.append('data[mobile]',0)
            axios.post(
                this.$store.state.SAMCOTEC.r_path , post
            ).then((response) => {
                this.classes = response.data.results.data;
                this.vendorAcType = this.classes[0]['classid'] ?? 0;
            })
        },
        checkVendorVat() {
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type','checkVendor');
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase))
            post.append('data[lang]',this.$cookies.get(this.$store.state.LangCooki))
            post.append('data[mobile]',0)
            post.append('data[vatid]',this.vatid)
            axios.post(
                this.$store.state.SAMCOTEC.r_path , post
            ).then((response) => {
                const res = response.data;
                if(res.results.data.length > 0){
                    this.$snotify.error('الرقم الضريبي مستخدم من قبل ', 'تنبيه', {
                        timeout: 1000000,
                        showProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        position: SnotifyPosition.centerCenter,
                        buttons: [
                            {
                                text: this.lang.close, 
                                action: (toast) => {
                                    this.$snotify.remove(toast.id); 
                                } 
                            },
                        ]
                    });
                }
                
            })
        },
        AddVendor(){
            if(this.full_name == '' || this.full_name.length < 5){
                this.$snotify.error(this.lang.vendor_name_required, 'تنبيه', {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.lang.close, 
                            action: (toast) => {
                                this.$snotify.remove(toast.id); 
                            } 
                        },
                    ]
                });
                return false;
            }
            if(this.mobile == '' || this.mobile.length < 5){
                this.$snotify.error(this.lang.vendor_mobile_required, 'تنبيه', {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.lang.close, 
                            action: (toast) => {
                                this.$snotify.remove(toast.id); 
                            } 
                        },
                    ]
                });
                return false;
            }
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type','addUpdateVendor');
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase))
            post.append('data[lang]',this.$cookies.get(this.$store.state.LangCooki))
            post.append('data[vendorid]',this.vendorid)
            post.append('data[mobile]',this.mobile)
            post.append('data[full_name]',this.full_name)
            post.append('data[address]',this.address)
            post.append('data[is_customer]',this.is_customer)
            post.append('data[vatid]',this.vatid)
            post.append('data[vendortype]',this.vendortype)
            post.append('data[vendorAcType]',this.vendorAcType)
            axios.post(
                this.$store.state.SAMCOTEC.r_path , post
            ).then((response) => {
                const res = response.data;
                this.$parent.getVendors();
                document.getElementById('vendorclose').click();
                this.$snotify.error(this.lang.vendor_updated_successufly, 'تنبيه', {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.lang.close, 
                            action: (toast) => {
                                this.$snotify.remove(toast.id); 
                            } 
                        },
                    ]
                });
            })
        }
    },
    created() {
        this.getVenClasses();
    }
}
</script>